module.exports = __webpack_public_path__ + "img/供应链下单.2d7f5ee6.png";